import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import {HiOutlineViewList} from "react-icons/hi";
import Moment from "react-moment";

function getProductsNewsletter() {

    return fetch('https://backapi.therunningcollective.fr/api/protected/newsletter/products', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class NewsletterProductsPageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productsNewsletter: null,
        }

    }

    async componentDidMount() {
        await getProductsNewsletter().then(data => {
            this.setState({productsNewsletter: data})
        }).catch(err =>
            this.setState({errors: "error while getting productsNewsletter"})
        );
    };

    renderTooltipImg = (declination) => (
        <Tooltip id="button-tooltip" >
            {declination ?
                <div key={declination.reference}>
                    <div>
                        <img className="imgToDisplay" alt="Couverture" src={"https://img.therunningcollective.fr/" + declination.declinationImg}/>
                    </div>
                    <br/>
                </div>
                : "Indisponible" }
        </Tooltip>
    );


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des productsNewsletter, veuillez vous reconnecter"</p> : null}

                { (!this.state.productsNewsletter && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Nom du produit</th>
                            <th>Référence</th>
                            <th>Taille recherchée</th>
                            <th>Email</th>
                            <th>Résolu</th>
                            <th>Date de demande</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.productsNewsletter.map(product => (
                            <tr
                                key={product.title}
                                id={product.id}
                            >
                                <OverlayTrigger
                                    placement="top"
                                    overlay={this.renderTooltipImg(product)}
                                >
                                    <td>{product.productName}</td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={this.renderTooltipImg(product)}
                                >
                                    <td>{product.declinationReference}</td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={this.renderTooltipImg(product)}
                                >
                                    <td>{product.researchedSize}</td>
                                </OverlayTrigger>
                                <td>{product.clientEmail} </td>
                                <td>{product.resolved ? "oui" : "non"}</td>
                                <td><Moment to={product.updatedDate}>{Date.now()}</Moment></td>
                                <td>{product.url}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
            </div>
        );

    }
}